import React from 'react';
import { useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import EventDisplay from '../components/EventDisplay';
import NoEventAlert from '../components/NoEventAlert';
import { displayEvent } from '../utils/displayEvent';

const Widget = () => {
	const { eventData, error } = useSelector(
		(state) => state.eventDetailsReducer
	);
	const labels = useLabels();
	const displayEventObj = displayEvent(eventData ?? {}, labels);

	return !displayEventObj || error ? (
		<NoEventAlert />
	) : (
		<EventDisplay event={displayEventObj} />
	);
};

export default Widget;
